export function getVehicleState(serviceLocations: any, values: any) {
  if (serviceLocations.vehicleLocation?.address?.state) return serviceLocations.vehicleLocation?.address?.state
  else if (serviceLocations.callerLocation?.address?.state) return serviceLocations.callerLocation?.address?.state
  else if (values.claim?.state?.value)
    return values.claim?.state?.value // LDR
  else if (values.vehicleState)
    return values.vehicleState // Update Event, actually event.vehicleState
  else return 'XX' // Escalation / Feature / Drop / Transfer / Callback
}

export default getVehicleState
